import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useClinic() {
  const { profile } = useAuth();

  return useQuery({
    queryKey: ['clinic', profile?.clinic_id],
    queryFn: async () => {
      if (!profile?.clinic_id) return null;

      const { data, error } = await supabase
        .from('clinics')
        .select('id, name')
        .eq('id', profile.clinic_id)
        .maybeSingle();

      if (error) throw error;
      return data;
    },
    enabled: !!profile?.clinic_id,
  });
}
